// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_5oU","cls2":"FullScreenPremiumModal-cls2_ieg FullScreenPremiumModal-cls1_5oU"};